module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/3_d09a01173331aca29723facd2699da3d.jpg";